module.exports = __webpack_public_path__ + "static/DSC_9512-77b044215296937fb17c8ae4baa0e403.jpg";